module.exports = __webpack_public_path__ + "static/media/scan.ec80c423.svg";